import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { ApiService } from '../api.service';
import { HandlerService } from '../handler.service';

@Component({
  selector: 'app-select-purchase-category',
  templateUrl: './select-purchase-category.component.html',
  styleUrls: ['./select-purchase-category.component.scss'],
})
export class SelectPurchaseCategoryComponent {

  loader: boolean = true;
  category;
  name;
  search:any=[];
  filterLength;
  img;
  url;
  constructor(    private router: Router,  public handler: HandlerService, private platform: Platform,
    public service: ApiService) { }
ionViewWillEnter(){
  this.url=window.location.href;
  this.getCategory();
}
cancel(){
  if(this.url.includes('vendor-Purchase-category')){
    this.router.navigate(['/vendor-request'])
  }else{
    this.router.navigate(['/requests'])
  }
  
}
getCategory(){
  this.service.getAllDetailedPurchaseCategory().subscribe((res: any) => {
    if(res){
      this.category=res;
      this.img = res.img;
      this.name=res.name;
      this.loader = false;
    }else{
      this.handler.res("No Data Found");
      this.loader = false;
    }
    
  },err=>{
    this.handler.err(err);
    this.loader=false;
  })
}

routeToItems(data){
  if(this.url.includes('contractor-Purchase-category')){
    this.router.navigate(['Contractor-Items/',+data.id])
  }else{
    this.router.navigate(['Vendor-Items/',+data.id])
  }


} 

}
